import React from 'react';

const FailedSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={259}
    height={206}
    viewBox="0 0 259 206"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx={122.081}
      cy={118.566}
      rx={78.0809}
      ry={75.7615}
      fill="#FFEEEE"
    />
    <ellipse
      cx={122.081}
      cy={118.566}
      rx={57.1324}
      ry={55.4352}
      fill="#FFD6D6"
    />
    <ellipse cx={122.379} cy={118.65} rx={42.0847} ry={40.65} fill="#E94F4F" />
    <path
      d="M53.7659 14.3534L60.499 7.82031"
      stroke="#B5B5B5"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M53.7659 7.82041L60.499 14.3535"
      stroke="#B5B5B5"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M198.501 197.289L205.234 190.756"
      stroke="#B5B5B5"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M198.501 190.756L205.234 197.289"
      stroke="#B5B5B5"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M24.7572 191.561C23.5017 191.561 22.2744 191.922 21.2304 192.599C20.1865 193.275 19.3729 194.237 18.8924 195.363C18.4119 196.488 18.2862 197.727 18.5312 198.922C18.7761 200.116 19.3807 201.214 20.2685 202.075C21.1563 202.937 22.2874 203.523 23.5188 203.761C24.7502 203.999 26.0266 203.877 27.1865 203.411C28.3465 202.944 29.3379 202.155 30.0354 201.142C30.733 200.129 31.1053 198.938 31.1053 197.72C31.1053 196.911 30.9411 196.11 30.622 195.363C30.303 194.616 29.8354 193.937 29.246 193.365C28.6565 192.793 27.9567 192.339 27.1865 192.029C26.4163 191.72 25.5909 191.561 24.7572 191.561ZM24.7572 202.648C23.7528 202.648 22.7709 202.359 21.9358 201.817C21.1007 201.276 20.4497 200.506 20.0654 199.606C19.681 198.705 19.5804 197.715 19.7764 196.759C19.9723 195.803 20.456 194.925 21.1662 194.236C21.8765 193.547 22.7813 193.077 23.7665 192.887C24.7516 192.697 25.7727 192.795 26.7007 193.168C27.6286 193.54 28.4218 194.172 28.9798 194.982C29.5378 195.793 29.8357 196.745 29.8357 197.72C29.8357 199.027 29.3006 200.28 28.3482 201.204C27.3958 202.128 26.1041 202.648 24.7572 202.648Z"
      fill="#B5B5B5"
    />
    <path
      d="M251.382 102.863C250.127 102.863 248.899 103.225 247.855 103.901C246.812 104.578 245.998 105.54 245.517 106.666C245.037 107.791 244.911 109.03 245.156 110.224C245.401 111.419 246.006 112.517 246.893 113.378C247.781 114.24 248.912 114.826 250.144 115.064C251.375 115.302 252.652 115.18 253.812 114.713C254.971 114.247 255.963 113.458 256.66 112.445C257.358 111.432 257.73 110.241 257.73 109.023C257.73 108.214 257.566 107.413 257.247 106.666C256.928 105.918 256.46 105.239 255.871 104.667C255.281 104.095 254.582 103.642 253.812 103.332C253.041 103.023 252.216 102.863 251.382 102.863ZM251.382 113.95C250.378 113.95 249.396 113.661 248.561 113.12C247.726 112.578 247.075 111.809 246.69 110.908C246.306 110.008 246.205 109.017 246.401 108.061C246.597 107.106 247.081 106.228 247.791 105.538C248.501 104.849 249.406 104.38 250.391 104.19C251.377 104 252.398 104.097 253.326 104.47C254.254 104.843 255.047 105.475 255.605 106.285C256.163 107.095 256.461 108.048 256.461 109.023C256.461 110.33 255.926 111.583 254.973 112.507C254.021 113.431 252.729 113.95 251.382 113.95Z"
      fill="#B5B5B5"
    />
    <ellipse
      cx={4.76103}
      cy={89.6196}
      rx={4.76103}
      ry={4.6196}
      fill="#E94F4F"
    />
    <ellipse
      cx={206.629}
      cy={30.4887}
      rx={4.76103}
      ry={4.6196}
      fill="#E94F4F"
    />
    <path
      d="M127.322 114.425L122.957 118.79L127.321 123.154C127.642 123.475 127.642 123.998 127.321 124.32C127.159 124.481 126.948 124.561 126.737 124.561C126.526 124.561 126.315 124.48 126.153 124.32L121.791 119.956L117.427 124.32C117.265 124.481 117.054 124.561 116.843 124.561C116.632 124.561 116.421 124.48 116.259 124.32C115.938 123.998 115.938 123.475 116.259 123.154L120.623 118.79L116.259 114.426C115.938 114.105 115.938 113.582 116.259 113.26C116.581 112.939 117.104 112.939 117.425 113.26L121.789 117.624L126.153 113.26C126.475 112.939 126.997 112.939 127.319 113.26C127.641 113.582 127.644 114.103 127.322 114.425ZM137.458 113.843V123.738C137.458 129.648 132.649 134.457 126.738 134.457H116.843C110.932 134.457 106.123 129.648 106.123 123.738V113.843C106.123 107.932 110.932 103.123 116.843 103.123H126.738C132.649 103.123 137.458 107.932 137.458 113.843ZM135.809 113.843C135.809 108.841 131.741 104.772 126.738 104.772H116.843C111.841 104.772 107.772 108.841 107.772 113.843V123.738C107.772 128.74 111.841 132.808 116.843 132.808H126.738C131.741 132.808 135.809 128.74 135.809 123.738V113.843Z"
      fill="white"
    />
  </svg>
);

export default FailedSVG;
